import { GetStaticProps } from 'next'
import { NextSeo } from 'next-seo'

import { Faq, FaqCategory as FaqCategoryType, strapi } from 'api'
import { FaqTrendingSection } from 'components/faqs'
import { CTASection } from 'sections/common/cta-section/cta-section'
import { FaqSearchSection } from 'sections/faqs'
import { REVALIDATION_ERROR_TIMEOUT, REVALIDATION_TIMEOUT } from 'const/config'

import { Section } from '../../components/section'
import { routes } from '../../utils/routes'
import { FaqCategoryInfo } from '../../components/faqs/faq-category-info'
import ArrowRight from '../../icons/long-arrow-right-current-color.svg'
import { Link } from '../../components/links'
import styles from './faqs.module.css'

interface Props {
  categories: FaqCategoryType[]
  trendingItems: Faq[]
}

export const getStaticProps: GetStaticProps<Props> = async () => {
  try {
    const [categories, trendingItems] = await Promise.all([
      strapi.faqCategories
        .find()
        .then(({ items }) => items.filter((category) => category.faqs?.length)),
      strapi.faqs.trendingItems(),
    ])
    return {
      props: { categories, trendingItems },
      revalidate: REVALIDATION_TIMEOUT,
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('FAQ Revalidate', e)
    return {
      notFound: true,
      revalidate: REVALIDATION_ERROR_TIMEOUT,
    }
  }
}

export default function FaqsListPage({ categories, trendingItems }: Props) {
  return (
    <>
      <NextSeo title="FAQs" />

      <FaqSearchSection />
      <FaqTrendingSection items={trendingItems} />

      <Section theme="outerGap">
        <ul className={styles.list}>
          {categories.map((item) => (
            <li key={item.id}>
              <Link href={routes.faqCategory(item.slug)} className={styles.block}>
                <FaqCategoryInfo item={item} />

                <ArrowRight className={styles.arrow} />
              </Link>
            </li>
          ))}
        </ul>
      </Section>

      <CTASection />
    </>
  )
}

FaqsListPage.layoutProps = {}
